import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";
import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import PinLegend from "@mapmycustomers/shared/types/map/PinLegend";

import { isSingleShapePinLegend } from "@app/util/pinLegend";

const getDefaultShapePinLegend = (
  pinLegends: PinLegend[],
  entityType: EntityTypesSupportedByMapsPage
): PinLegend | undefined =>
  pinLegends.find(
    (legend) =>
      isSingleShapePinLegend(legend) &&
      legend.entity === entityType &&
      legend.thematic.shapes[0].shape === MarkerShape.SQUARE
  );

export default getDefaultShapePinLegend;
